import { render, staticRenderFns } from "./LongFlatCard.vue?vue&type=template&id=494f88ac&lang=pug&"
import script from "./LongFlatCard.vue?vue&type=script&lang=ts&"
export * from "./LongFlatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports